import React, { useState,useEffect, useRef } from "react";
import { isHTML } from "../../../../../utils/helpers";
const generateSrcDoc = (htmlBody) => `
  <html>
    <head>
    <link rel="stylesheet" href="/fonts/style.css" />
       <style>
        body {
          margin-left: 10;
          font-family: "Oakes-Grotesk-Medium";
          font-size : 14px;
          color: #555;
        }
      </style>
    </head>
    <body>
      ${htmlBody}
      <script>
        function sendHeight() {
          const height = document.body.scrollHeight;
          parent.postMessage({ type: 'setHeight', height }, '*');
        }
        window.onload = sendHeight;
        window.onresize = sendHeight;
      </script>
    </body>
  </html>
`;
export default function ConfirmCancel({ deleteUser,cancelRequest, id, payment_status="" , cancellation_policy=""  }) {
  const iframeRef = useRef(null);
      const [iframeHeight, setIframeHeight] = useState("100px");
      useEffect(() => {
              const handleMessage = (event) => {
                  if (event.data && event.data.type === "setHeight") {
                      let height =  event.data.height + 65;
                  setIframeHeight(height + "px");
                  }
              };
      
              window.addEventListener("message", handleMessage);
              return () => window.removeEventListener("message", handleMessage);
              }, []);
    const getInfo = (info) => {

        const rawContentFromDB = info
        let html;
        if (!isHTML(rawContentFromDB)) {
            console.log( info,"ckejdnm1")
            let info =
                rawContentFromDB
                    .split("\n")
                    .map(line => `${line}`)
                    .join("");
            console.log(info, "cejdncjkm");
            html = info
            return info
        }
        else {
           // console.log( info,"ckejdnm2anuj")
            // html = JSON.parse(rawContentFromDB).content
            // return <div dangerouslySetInnerHTML={{ __html: rawContentFromDB }} />
            
              html = JSON.parse(rawContentFromDB).content
              const srcDoc = generateSrcDoc(html);
            return srcDoc 
        }

// "{\"content\":\"<p style=\\\"margin-left:0px;\\\">Try a Community Support Group:</p>\\n<ol>\\n<li><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Male Mediums - Ed S. Mediums Who Speak French - Cindy L.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unsupported: Doubt/Fear from Family/Friends = Lisa A.</span></li>\\n<li style=\\\"margin-left:0px;\\\"><span style=\\\"font-size: 12px;font-family: Helvetica;\\\">Unity: Group Meditation - Amber K. Healing Session for Mediums - Catherine B.</span></li>\\n</ol>\\n\"}"

    }
    // This effect runs when the component mounts or when the id changes
  return (
    <div className="confirm-delete-wrapper cancelation-popup-show register-medium">
      <div data-backdrop="static" className="modal fade" id={id} role="dialog">
        <div className="modal-dialog padding-unset modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                <img src="images/Union-icon.png" alt="Union-icon" />
              </div>
              <h3>Are you sure?</h3>
              {payment_status === "Paid" && cancellation_policy !== "" && (
                <>
                <p className="cancellation-policy"><b>Client Cancellation Policy</b></p>
                 <iframe 
                    ref={iframeRef}
                    srcDoc={getInfo(cancellation_policy)}
                    style={{ width: "100%",height: iframeHeight, border: "unset" }}
                    title="Editor Preview"
                    />
                    </>
              )}
              <div className="confirm-btn-box cancelation-popup-box">
                <div
                  className="register-medium-confirnation model-close-btn"
                  onClick={cancelRequest}
                  data-dismiss="modal"
                >
                  Cancel
                </div>
                <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                  onClick={deleteUser}
                >
                  Confirm
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
